import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BehaviorSubject, Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {SERVER_API_URL} from '@app/app.constants';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private _currentPlantSubject = new BehaviorSubject(null);

  currentPlant$: Observable<any> = this._currentPlantSubject.asObservable();

  constructor(private http: HttpClient) {}

  getCurrentPlant(): Observable<any> {
    return this.http.get<string>(SERVER_API_URL + 'api/current-plant').pipe(
      map((currentPlantId: any) => {
        this._currentPlantSubject.next(currentPlantId);
        return currentPlantId;
      }),
    );
  }

  changePlant(plantId) {
    this._currentPlantSubject.next(plantId);
  }
}
